import { SortOptions, SortState } from './types'

/**
 * Класс для управления сортировкой каталога квестов
 */
export class Sort {
  private element: HTMLElement
  private options: SortOptions
  private state: SortState

  // DOM элементы
  private dropdown: HTMLElement

  /**
   * Создаёт экземпляр CatalogSort
   *
   * @param {SortOptions} options - Опции сортировки
   */
  constructor(options: SortOptions) {
    this.options = options
    this.element = options.element

    // Инициализируем состояние
    this.state = {
      value: options.value || 'popular'
    }

    this.init()
  }

  private init(): void {
    this.getElements()
    this.bindEvents()
    this.setInitialValue()
  }

  private setInitialValue(): void {
    // Устанавливаем начальное значение в дропдаун
    if (this.dropdown && this.state.value) {
      const event = new CustomEvent('set-value', {
        detail: { value: this.state.value }
      })
      this.dropdown.dispatchEvent(event)
    }
  }

  private getElements(): void {
    this.dropdown = this.element.querySelector('[data-dropdown]') as HTMLElement
  }

  private bindEvents(): void {
    // Слушаем изменения от дропдауна
    if (this.dropdown) {
      this.dropdown.addEventListener('dropdown-change', (event: Event) => {
        const customEvent = event as CustomEvent
        const { value } = customEvent.detail
        this.handleChange(value)
      })
    }
  }

  private handleChange(value: string): void {
    this.state.value = value

    if (this.options.onChange) {
      this.options.onChange(value)
    }

    // Отправляем событие для каталога
    const event = new CustomEvent('sort-change', {
      detail: value,
      bubbles: true
    })
    this.element.dispatchEvent(event)
  }

  /**
   * Возвращает текущее значение сортировки
   *
   * @return {any} Значение сортировки
   */
  // Публичные методы
  public getValue(): string {
    return this.state.value
  }

  /**
   * Устанавливает значение сортировки
   *
   * @param {string} value - Новое значение сортировки
   */
  public setValue(value: string): void {
    this.state.value = value

    // Устанавливаем значение в дропдаун
    if (this.dropdown) {
      const event = new CustomEvent('set-value', {
        detail: { value }
      })
      this.dropdown.dispatchEvent(event)
    }
  }

  /**
   * Уничтожает экземпляр сортировки
   */
  public destroy(): void {
    // Удаляем обработчики при необходимости
  }
}
